import { Movimiento } from "./movimiento";
import { Bodega } from "./bodega";
import { TransferenciasDetalle } from './transferencias-detalle';
import { Guiaremision } from "./guiaremision";

export class Transferencias {

    public constructor(
        public id: String = "",
        public bodega_id_entrada: String = "",
        public bodega_id_salida: String = "",
        public movimiento_id: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public cantidad: number = 0,
        public usuario_id:String = null,
        public fecha_ingreso:String ="",
        public detalle: Array<TransferenciasDetalle> = [],
        public movimiento: Movimiento = new Movimiento(),
        public bodegaS: Bodega = new Bodega(),
        public bodegaE: Bodega = new Bodega(),

        //
        public bodega_s: Bodega = new Bodega(),
        public bodega_e: Bodega = new Bodega(),
        //
        public guiaremision: Guiaremision = new Guiaremision()
    ){
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/transferencias.ts